import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassMinus } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const ZoomOutIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faMagnifyingGlassMinus} style={{ color }} width={20} height={20} />;
};

export default ZoomOutIcon;
